<table *ngIf="metaContact" class="table  table-bordered  table-sm  mb-0">
    <tr *ngIf="metaContact.getContactFieldBySlug('initials')">
        <td>Init:</td>
        <td><b>{{metaContact.getContactFieldBySlug('initials') ? metaContact.getContactFieldBySlug('initials') : '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldBySlug('phone')">
        <td>Tlf:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('phone') ? invoiceContact.getContactFieldBySlug('phone') : '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldBySlug('fax')">
        <td>Fax:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('fax') ? invoiceContact.getContactFieldBySlug('fax') : '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldBySlug('phone')">
        <td>Mobil:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('phone') ? invoiceContact.getContactFieldBySlug('phone') : '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldBySlug('sms')">
        <td>SMS til:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('sms') ? invoiceContact.getContactFieldBySlug('sms') : '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldBySlug('cvr')">
        <td>CVR nummer:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('cvr') ? invoiceContact.getContactFieldBySlug('cvr') : '-'}}</b></td>
    </tr>
    <tr *ngIf="order.isDebtor() && order.debtor && order.debtor.price_groups.length > 0">
        <td>Prislister / Rabat</td>
        <td>
            <ul class="list-unstyled  mb-0">
                <ng-template *ngIf="order.debtor" ngFor let-priceGroup [ngForOf]="order.debtor.price_groups">
                    <li><strong>{{ priceGroup.name }}</strong></li>
                </ng-template>
            </ul>

            <strong *ngIf="order.debtor && order.debtor.price_groups.length > 0">-</strong>
        </td>
    </tr>
</table>
